module.exports = __webpack_public_path__ + "static/media/instagramBackground_2.bfb0b2e9.jpg";